<div class="container">
    <h2>Discrepancies</h2>
    
    <nz-table #basicTable [nzData]="discrepancies" [nzLoading]="isLoading">
      <thead>
        <tr>
          <th>Account Number</th>
          <th>Customer Name</th>
          <th>Address</th>
          <th>Sale Date</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of basicTable.data">
          <td>{{ order.order_id }}</td>
          <td>{{ order.first_name | titlecase }} {{ order.last_name | titlecase }}</td>
          <td>{{ order.address_line_1 }}, {{ order.address_city }}, {{ order.address_state }}</td>
          <td>{{ order.sale_date | date }}</td>
          <td>
            <button nz-button nzType="primary" (click)="showResolveModal(order)">
              Resolve
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <nz-modal [(nzVisible)]="isModalVisible"  nzTitle="Resolve Discrepancy" (nzOnCancel)="handleCancel()" [nzFooter]="null" [nzClosable]="true">
    <ng-container *nzModalContent>

      <nz-card>

        <div>
          <nz-typography nzTitle><strong> Rep Submitted Date: </strong></nz-typography>
          <nz-typography>{{ selectedOrder?.generic.discrepancy_review.rep_submit_date | date }}</nz-typography>
        </div>

        <div>
          <nz-typography nzTitle><strong> Fidium Submit Date: </strong></nz-typography>
          <nz-typography>{{ selectedOrder?.generic.discrepancy_review.submitted_date | date }}</nz-typography>
        </div>

        <div>
          <nz-typography nzTitle><strong> Rep Note: </strong></nz-typography>
          <nz-typography>{{ selectedOrder?.generic.discrepancy_review.rep_notes }}</nz-typography>
        </div>

      </nz-card>

      <button style="margin-top: 10px;" nz-button nzType="primary" (click)="submit()" *ngIf="!selectedOrder?.generic.discrepancy_review.submitted">Submit to Fidium</button>

         <div style="margin-top: 5px;" *ngIf="selectedOrder?.generic.discrepancy_review.submitted">
            <ng-container>
                <textarea nz-input [(ngModel)]="discrepancy_note" fill="outline" placeholder="Enter Results"></textarea>
            </ng-container>
         </div>

         <button style="margin-top: 10px;" nz-button nzType="primary" (click)="handleOk()" *ngIf="selectedOrder?.generic.discrepancy_review.submitted">Complete</button>
    </ng-container>
  </nz-modal>